import { Button } from "@chakra-ui/button";
import { Formik, Form } from "formik";
import styled from "styled-components";
import * as Yup from "yup";
import { Text } from "@chakra-ui/layout";
import emailjs from "@emailjs/browser";
import { useToast } from "@chakra-ui/toast";
// import { Link } from "react-router-dom";
import { MyCheckbox } from "./common/MyCheckbox";
import { MyInput } from "./common/MyInput";
import { MyTextarea } from "./common/MyTextArea";
import { MiniHeaderWrapper, SuccessToast } from "./contactForm.styled";
import { useRef } from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const MyInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  margin-left: 38px;
  > * + * {
    margin-top: 25px;
  }
  /* font-size: 14px; */
  @media (max-width: 800px) {
    > * + * {
      margin-top: 15px;
    }
    /* font-size: 12px; */
  }
`;

const MyText = styled(Text)`
  font-size: 11px;
  @media (max-width: 600px) {
    font-size: 8px;
  }
`;

export const ContactForm = () => {
  const toast = useToast();
  const toastIdRef = useRef();

  const close = () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
  };

  const addToast = (status) => {
    toastIdRef.current = toast({
      position: "bottom",
      duration: 8000,
      isClosable: true,
      render: () => (
        <SuccessToast status={status}>
          <MiniHeaderWrapper className="MiniHeaderWrapper">
            <IoMdCheckmarkCircleOutline />
            <h1>
              {status === "success"
                ? "Form submitted!"
                : "Error submitting form"}
            </h1>
          </MiniHeaderWrapper>
          <p>
            {status === "success"
              ? "Thank you for contacting me. I will get back to you soon."
              : "There was an error processing your request"}
          </p>
          <button onClick={() => close()}>x</button>
        </SuccessToast>
      ),
    });
  };

  return (
    <>
      <Formik
        initialValues={{
          firstAndLastName: "",
          email: "",
          message: "Hi",
          acceptedTerms: false, // added for my checkbox
        }}
        validationSchema={Yup.object({
          firstAndLastName: Yup.string()
            .max(30, "Must be 30 characters or less")
            .required("Required"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Required"),
          message: Yup.string()
            .min(2, "Must be 2 or more characters")
            .max(200, "Maximum number of 200 characters")
            .required("Required"),
          acceptedTerms: Yup.boolean()
            .required("Required")
            .oneOf([true], "You must accept the terms and conditions."),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          await new Promise((r) => setTimeout(r, 2000));
          setSubmitting(false);

          emailjs
            .send(
              "service_4e0aw5l",
              "template_lhq1atf",
              values,
              "ycLId8KmxBBBU8RAO"
            )
            .then(
              function (response) {
                // console.log("SUCCESS!", response.status, response.text);
                if (response) {
                  addToast("success");
                }
              },
              function (error) {
                // console.log("FAILED...", error);
                if (error) {
                  addToast("error");
                }
              }
            );
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <MyInputsWrapper className="MyInputsWrapper">
              <MyInput
                label="Name and Surname"
                name="firstAndLastName"
                type="text"
                id="my-input"
                //   children={
                //     <IoMdContact style={{ width: "30px", height: "30px" }} />
                //   }
              />
              <MyInput
                label="Email Address"
                name="email"
                type="email"
                id="my-input"
                //   children={
                //     <FaPaperPlane style={{ width: "25px", height: "25px" }} />
                //   }
              />
              <MyTextarea
                label="Message"
                name="message"
                type="text"
                size="md"
                resize="none"
              />
              <MyText>
                This contact form collects your personal data, so I can
                communicate with you to say hello back or discuss potential
                opportunities
              </MyText>
              <MyCheckbox
                value="Checkbox"
                name="acceptedTerms"
                type="checkbox"
                style={{
                  // border: "1px solid var(--main-color)",
                  height: "18px",
                  width: "18px",
                }}
              >
                I accept that Vasil collects my data through this contact form.
              </MyCheckbox>
              <Button
                type="submit"
                style={{
                  height: "35px",
                  width: "100%",
                  // borderRadius: "4px!important",
                  backgroundColor: "#232323",
                  border: "1px solid var(--main-color)",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </MyInputsWrapper>
          </Form>
        )}
      </Formik>
    </>
  );
};
